<template>
    <div class="n2-center-container">
        <div class="n2-content" style="position: relative;">
            <div style="margin: 10px;">
                <a v-on:click="$router.go(-1)" class="n2-link-back">
                    <div style="display: flex; align-items:center;">
                        <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                        <span style="margin-left:5px;">
                            {{ $t('pages.admin.order.back') }}
                        </span>
                    </div>
                </a>
            </div>

            <div class="n2-margin-top" style="background-color: #ffffff; position: relative;">
                <div style="border-bottom:1px solid #cccccc;">
                    <div class="n2-toolbar n2-content">
                        <!-- <div v-if="order.support_status != 'open'" class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="openSupport">
                                <i class="fa fa-toggle-off n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.support') }}
                                </span>
                            </button>
                        </div>
                        <div v-else class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="closeSupport">
                                <i class="fa fa-toggle-on n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.support') }}
                                </span>
                            </button>
                        </div> -->
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="download(order)">
                                <i class="fa fa-file-pdf-o n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.download_pdf') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="openAddFeeModal()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.add_fee') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-bind:disabled="order.status == 'cancelled'"
                                v-bind:class="{ 'disabled': order.status == 'cancelled' }"
                                v-on:click="openModal('n3-cancel-modal')">
                                <i class="fa fa-recycle n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.cancel') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="openRefundModal()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.refund') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="openEmailModal()">
                                <i class="fa fa-paper-plane n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.send_email') }}
                                </span>
                            </button>
                        </div>
                        <div class="n2-toolbar-item">
                            <button class="n2-toolbar-button" v-on:click="openAddNoteModal()">
                                <i class="fa fa-sticky-note n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.add_note') }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <app-loader v-bind:active="toolbar_loading"></app-loader>
            </div>
            <div style="padding: 5px 16px; background-color: #fff;">
                <question-content v-bind:name="'admin.order.frequently_asked_questions'"></question-content>
            </div>
            <div class="n3-order-detail" style="padding: 0 10px;">
                <div>
                    <div style="float: left; margin: 0 20px 0 0;">
                        <div style="margin: 0 0 5px; padding: 0 10px; font-weight: bold;">
                            {{
                                $t('pages.admin.order.order_detail')
                            }}
                        </div>
                        <table>
                            <tr>
                                <td>{{ $t('pages.admin.order.booking_number') }}</td>
                                <td>{{ order.booking_number }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.created_at') }}</td>
                                <td>{{ getDateTimeString(order.created_at) }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.cancelled_at') }}</td>
                                <td>{{ getDateTimeString(order.cancelled_at) }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.status') }}</td>
                                <td>{{ order.status }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.financial_status') }}</td>
                                <td>{{ order.financial_status }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.travel_status') }}</td>
                                <td>{{ order.travel_status }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.support_status') }}</td>
                                <td>{{ order.support_status }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.locale') }}</td>
                                <td>{{ order.locale }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.discount_code') }}</td>
                                <td>{{ order.discount_code }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.client_id') }}</td>
                                <td>{{ order.client_id }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.template') }}</td>
                                <td class="n2-text-right">{{ order.template }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.original_ticket_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.original_ticket_total) }} NOK</td>
                            </tr>

                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{
                                        $t('pages.admin.order.ticket_prices')
                                    }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.list_price_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.list_price_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.discount_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.discount_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.net_price_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.net_price_total) }} NOK</td>
                            </tr>

                            <tr>
                                <td>{{ $t('pages.admin.order.ticket_tax_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.ticket_tax_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.ticket_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.ticket_total) }} NOK</td>
                            </tr>

                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{ $t('pages.admin.order.fees') }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.cancellation_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.cancellation_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.change_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.change_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.insurance_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.insurance_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.manual_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.manual_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.fee_total) }} NOK</td>
                            </tr>

                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{
                                        $t('pages.admin.order.total_prices')
                                    }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.tax_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.tax_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.paid_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.paid_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.outstanding_amount') }}</td>
                                <td class="n2-text-right">{{ formatNumber(order.outstanding_amount) }} NOK</td>
                            </tr>

                        </table>
                    </div>
                    <div style="float: left; margin: 0 20px 0 0;">
                        <div style="display: flex; justify-content: start; align-items: center;">
                            <div style="padding: 0 10px; font-weight: bold;">
                                {{
                                    $t('pages.admin.order.contact')
                                }}
                            </div>
                            <div>
                                <div class="n2-button-2" v-on:click="openModal('n3-change-contact-modal')">
                                    <span class="material-symbols-outlined">edit</span>
                                </div>
                            </div>
                        </div>
                        <table v-if="order.contact">
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.name') }}
                                </td>
                                <td>
                                    {{ order.contact.given_name }}
                                    {{ order.contact.middle_name }}
                                    {{ order.contact.family_name }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.email') }}
                                </td>
                                <td>
                                    {{ order.contact.email }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.phone_number') }}
                                </td>
                                <td>
                                    {{ order.contact.phone_number }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.address') }}
                                </td>
                                <td>
                                    {{ order.contact.address.address_line_1 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.locality') }}
                                </td>
                                <td>
                                    {{ order.contact.address.locality }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.postal_code') }}
                                </td>
                                <td>
                                    {{ order.contact.address.postal_code }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.country_code') }}
                                </td>
                                <td>
                                    {{ order.contact.address.country_code }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                <div style="margin-top: 20px;">
                    <div style="margin-bottom: 5px; padding-left: 10px; font-weight: bold;">
                        {{ $t('pages.admin.order.ticket_products') }}
                    </div>
                    <div>
                        <table>
                            <tr>
                                <td>{{ $t('pages.admin.order.type') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.quantity') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.list_price') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.discount') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.net_price') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.tax_total') }}</td>
                                <td style="text-align: right;">{{ $t('pages.admin.order.total') }}</td>
                            </tr>
                            <tr v-for="pline in order.product_lines" v-bind:key="pline.product_id" style="">
                                <td>{{ pline.title }}</td>
                                <td style="text-align: right;">{{ pline.quantity }}</td>
                                <td style="text-align: right;">{{ formatNumber(pline.list_price) }} NOK</td>
                                <td style="text-align: right;">{{ formatNumber(pline.discount_amount) }} NOK</td>
                                <td style="text-align: right;">{{ formatNumber(pline.net_price) }} NOK</td>
                                <td style="text-align: right;">{{ formatNumber(pline.line_tax) }} NOK</td>
                                <td style="text-align: right;">{{ formatNumber(pline.line_total) }} NOK</td>
                            </tr>
                            <!-- <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align: right;">{{ formatNumber(order.ticket_tax_total) }} NOK</td>
                                <td style="text-align: right;">{{ formatNumber(order.ticket_total) }} NOK</td>
                            </tr> -->
                        </table>
                    </div>
                </div>

                <div style="margin-top: 20px;">
                    <div style="display: flex; justify-content:start; align-items: center;">
                        <div style="padding: 0 10px; font-weight: bold;">
                            {{ $t('pages.admin.order.vehicles') }}
                        </div>
                        <div>
                            <div class="n2-button-2" v-on:click="openModal('n3-change-vehicle-modal')">
                                <span class="material-symbols-outlined">edit</span>
                            </div>
                        </div>
                    </div>

                    <table>
                        <tr>
                            <td>{{ $t('pages.admin.order.registration_number') }}</td>
                            <td>{{ $t('pages.admin.order.make') }}</td>
                            <td>{{ $t('pages.admin.order.model') }}</td>
                            <!-- <td>{{ $t('pages.admin.order.color') }}</td> -->
                        </tr>
                        <tr v-for="(vehicle, tindex) in order.vehicles" v-bind:key="tindex">
                            <td>{{ vehicle.registration_number }}</td>
                            <td>{{ vehicle.make }}</td>
                            <td>{{ vehicle.model }}</td>
                            <!-- <td>{{ vehicle.color }}</td> -->
                        </tr>
                    </table>
                </div>

                <div style="margin-top: 20px;">
                    <div style="margin-bottom: 5px; padding-left: 10px; font-weight: bold;">
                        {{ $t('pages.admin.order.transactions') }}
                    </div>
                    <table>
                        <tr>
                            <td>{{ $t('pages.admin.order.date') }}</td>
                            <td>{{ $t('pages.admin.order.gateway') }}</td>
                            <td>{{ $t('pages.admin.order.gateway_transaction_id') }}</td>
                            <td>{{ $t('pages.admin.order.gateway_order_id') }}</td>
                            <td>{{ $t('pages.admin.order.amount') }}</td>
                            <td>{{ $t('pages.admin.order.currency') }}</td>
                        </tr>
                        <tr v-for="(transaction, tindex) in trans" v-bind:key="tindex">
                            <td>{{ getDateTimeString(transaction.created_at) }}</td>
                            <td>{{ transaction.gateway }}</td>
                            <td>{{ transaction.gateway_transaction_id }}</td>
                            <td>{{ transaction.gateway_order_id }}</td>
                            <td style="text-align:right;">
                                {{ transaction.transaction_type == 'credit' ? formatNumber(-transaction.amount) :
                                    formatNumber(transaction.amount) }}
                            </td>
                            <td>{{ transaction.currency }}</td>
                        </tr>
                    </table>
                </div>

                <div style="padding-bottom: 20px;">
                    <div v-for="leg in order.legs" v-bind:key="leg.id"
                        style="margin-top: 20px; border:10px solid #cccccc;">
                        <div style="background-color: #f1f2f3;  padding: 5px;">
                            <span style="font-weight: bold;">
                                <span class="trip-cell">{{ $t('pages.admin.order.status') }}: </span>
                                <span> {{ leg.status }} </span>
                            </span>
                            <span v-if="leg.status == 'cancelled'" class="n2-text-cancelled"
                                style="padding-left: 30px;">
                                <span>{{ $t('pages.admin.order.cancelled_at') }}: </span>
                                <span>{{ getDateTimeString(leg.cancelled_at) }}</span>
                            </span>
                        </div>

                        <div style="padding: 10px; font-size: 18px; text-align: center;"
                            v-if="leg.time_until_departure">{{
                                $t('pages.admin.order.time_to_departure') + ': ' +
                                getLegTime(leg) }}
                        </div>
                        <div style="margin:10px 0;" class="order-trips">
                            <div class="trip-row trip-header">
                                <div class="trip-cell">{{ $t('pages.admin.order.departure') }}</div>
                                <div class="trip-cell">{{ $t('pages.admin.order.arrival') }}</div>
                                <div class="trip-cell">{{ $t('pages.admin.order.vechile_type') }}</div>
                                <div class="trip-cell">{{ $t('pages.admin.order.route') }}</div>

                            </div>
                            <div v-for="step in leg.steps" v-bind:key="step.id" class="trip-row"
                                v-bind:class="{ 'n2-text-cancelled': leg.status == 'cancelled' }">
                                <template v-if="step.travel_mode == 'transit'">

                                    <div class="trip-cell">
                                        {{
                                            getShortDateTimeString(step.transit.depart_at)
                                        }} {{
                                            step.transit.departure_stop.name
                                        }}
                                    </div>
                                    <div class="trip-cell">
                                        {{
                                            getShortDateTimeString(step.transit.arrive_at)
                                        }} {{
                                            step.transit.arrival_stop.name
                                        }}
                                    </div>
                                    <div class="trip-cell">
                                        {{ step.transit.vehicle_type }}
                                    </div>
                                    <div class="trip-cell">
                                        {{ step.transit.route.name }}
                                    </div>

                                </template>

                            </div>
                        </div>
                        <table>
                            <tr>
                                <td>{{ $t('pages.admin.order.original_ticket_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.original_ticket_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{
                                        $t('pages.admin.order.fees')
                                    }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.cancellation_fee_total') }}</td>
                                <td class="n2-text-right">
                                    {{ formatNumber(leg.cancellation_fee_total) }} NOK
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.insurance_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.insurance_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.manual_fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.manual_fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.fee_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.fee_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{
                                        $t('pages.admin.order.ticket_prices')
                                    }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.list_price_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.list_price_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.discount_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.discount_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.net_price_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.net_price_total) }} NOK</td>
                            </tr>

                            <tr>
                                <td>{{ $t('pages.admin.order.ticket_tax_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.ticket_tax_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.ticket_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.ticket_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td style="padding-top: 10px; font-weight: bold;">
                                    {{ $t('pages.admin.order.total_prices') }}
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.tax_total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.tax_total) }} NOK</td>
                            </tr>
                            <tr>
                                <td>{{ $t('pages.admin.order.total') }}</td>
                                <td class="n2-text-right">{{ formatNumber(leg.total) }} NOK</td>
                            </tr>
                        </table>
                        <div style="margin-top: 20px;">
                            <div class="n2-toolbar">
                                <div class="n2-toolbar-item">
                                    <button class="n2-toolbar-button" v-on:click="openAddLegFeeModal(leg)">
                                        <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                        <span v-on:click="openRefundModal()" class="n2-button-item-text">
                                            {{ $t('pages.admin.order.add_leg_fee') }}
                                        </span>
                                    </button>
                                </div>
                                <div class="n2-toolbar-item">
                                    <button class="n2-toolbar-button" v-bind:disabled="leg.status == 'cancelled'"
                                        v-bind:class="{ 'disabled': leg.status == 'cancelled' }"
                                        v-on:click="openCancelLegModal(leg.id)">
                                        <i class="fa fa-recycle n2-button-item-icon" aria-hidden="true"></i>
                                        <span class="n2-button-item-text">
                                            {{ $t('pages.admin.order.cancel_leg') }}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-timelines v-bind:timelines="timelines"></app-timelines>
            <app-loader v-bind:active="loading"></app-loader>
        </div>
        <div style="background:#fff; padding:10px; margin: 50px 10px 10px;">
            <div v-html="order_html"></div>
        </div>

        <div v-for="(orderHtml, index) in parentHtmls" v-bind:key="index" class="n2-margin-top"
            style="background:#fff; padding:20px;">
            <div v-html="orderHtml"></div>
        </div>


        <div id="n3-refund-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.refund') }}
                    </h4>
                    <div>
                        <form-input v-bind:type="'number'" v-bind:step="0.01" v-model="refund_amount"
                            v-bind:label="$t('pages.admin.order.refund_amount')"
                            v-bind:errors="refund_validation_errors.refund_amount"></form-input>
                        <validation-summary v-bind:errors="refund_validation_errors"></validation-summary>
                        <div class="n2-margin-top">
                            <button class="n2-button-icon" v-on:click="refund">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.refund') }}
                                </span>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div v-if="refund_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.refund_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.refund'"></question-content>
                </div>
                <app-loader v-bind:active="refund_loading"></app-loader>
            </div>
        </div>

        <div id="n3-cancel-leg-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.cancel_leg') }}
                    </h4>
                    <div>
                        {{ $t('pages.admin.order.cancel_leg_desc') }}
                    </div>
                    <div>
                        <div class="n2-margin-top">
                            <button class="n2-button-1" v-on:click="cancelLeg()">
                                {{ $t('pages.admin.order.cancel_leg') }}
                            </button>
                        </div>
                    </div>
                    <div>
                        <div v-if="cancel_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.cancel_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.cancel_leg'"></question-content>
                </div>
                <app-loader v-bind:active="cancel_leg_loading"></app-loader>
            </div>
        </div>

        <div id="n3-cancel-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.cancel') }}
                    </h4>
                    <div>
                        {{ $t('pages.admin.order.cancel_desc') }}
                    </div>
                    <div>
                        <div class="n2-margin-top">
                            <button class="n2-button-1" v-on:click="cancel()">
                                {{ $t('pages.admin.order.cancel') }}
                            </button>
                        </div>
                    </div>
                    <div>
                        <div v-if="cancel_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.cancel_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.cancel_entire_order'"></question-content>
                </div>
                <app-loader v-bind:active="cancel_order_loading"></app-loader>

            </div>
        </div>

        <div id="n3-send-email-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.send_email') }}
                    </h4>
                    <div>
                        <div class="n2-margin-top">
                            <div>
                                <form-input v-bind:type="'text'" v-model="email_to_send"
                                    v-bind:label="$t('pages.admin.order.email')"></form-input>
                            </div>
                            <div>
                                <button class="n2-button-icon" v-on:click="sendEmail()">
                                    <i class="fa fa-paper-plane n2-button-item-icon" aria-hidden="true"></i>
                                    <span class="n2-button-item-text">
                                        {{ $t('pages.admin.order.send_email') }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div v-if="send_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.send_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.send_ticket_email'"></question-content>
                </div>
                <app-loader v-bind:active="send_email_loading"></app-loader>

            </div>
        </div>

        <div id="n3-add-fee-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.add_fee') }}
                    </h4>
                    <div>
                        <form-input type="select" v-model="fee_type" v-bind:label="$t('pages.admin.order.type')">
                            <template v-slot:options>
                                <option value="cancellation">{{ $t('pages.admin.order.cancellation') }}</option>
                                <option value="insurance">{{ $t('pages.admin.order.insurance') }}</option>
                                <option value="manual">{{ $t('pages.admin.order.manual') }}</option>
                            </template>
                        </form-input>

                        <div v-if="fee_type == 'cancellation'" style="margin: 20px 0;">
                            <button class="n2-button-icon" v-on:click="getCancellationFee()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.calculate_cancellation_fee') }}
                                </span>
                            </button>
                        </div>
                        <form-input v-bind:type="'number'" v-model="fee_amount_percentage"
                            v-bind:label="`${$t('pages.admin.order.percentage')}: ${formatNumber(order.original_ticket_total)} NOK`"></form-input>
                        <form-input v-bind:type="'number'" v-bind:step="0.01" v-model="fee_amount"
                            v-bind:label="$t('pages.admin.order.amount')"></form-input>
                        <div class="n2-margin-top">
                            <button class="n2-button-icon" v-on:click="addFee()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.add_fee') }}
                                </span>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div v-if="add_fee_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.add_fee_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.adjust_fee'"></question-content>
                </div>
                <app-loader v-bind:active="add_fee_loading"></app-loader>

            </div>
        </div>

        <div id="n3-add-leg-fee-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.add_leg_fee') }}
                    </h4>
                    <div>
                        <form-input type="select" v-model="leg_fee_type" v-bind:label="$t('pages.admin.order.type')">
                            <template v-slot:options>
                                <option value="cancellation">{{ $t('pages.admin.order.cancellation') }}</option>
                                <option value="insurance">{{ $t('pages.admin.order.insurance') }}</option>
                                <option value="manual">{{ $t('pages.admin.order.manual') }}</option>
                            </template>
                        </form-input>

                        <div v-if="leg_fee_type == 'cancellation'" style="margin: 20px 0;">
                            <button class="n2-button-icon" v-on:click="getLegCancellationFee()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.calculate_cancellation_fee') }}
                                </span>
                            </button>
                        </div>
                        <form-input v-bind:type="'number'" v-model="leg_fee_amount_percentage"
                            v-bind:label="`${$t('pages.admin.order.percentage')}: ${selected_leg ? formatNumber(selected_leg.original_ticket_total) : ''} NOK`"></form-input>
                        <form-input v-bind:type="'number'" v-bind:step="0.01" v-model="leg_fee_amount"
                            v-bind:label="$t('pages.admin.order.amount')"></form-input>
                        <div class="n2-margin-top">
                            <button class="n2-button-icon" v-on:click="addLegFee()">
                                <i class="fa fa-usd n2-button-item-icon" aria-hidden="true"></i>
                                <span class="n2-button-item-text">
                                    {{ $t('pages.admin.order.add_leg_fee') }}
                                </span>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div v-if="add_leg_fee_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.add_leg_fee_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:0 16px 16px; margin-top: -22px;">
                    <question-content v-bind:name="'admin.order.adjust_leg_fee'"></question-content>
                </div>
                <app-loader v-bind:active="add_leg_fee_loading"></app-loader>

            </div>
        </div>

        <div id="n3-add-note-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container" style="padding-bottom: 16px;">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.add_note') }}
                    </h4>
                    <div>
                        <textarea v-model="note" style="width: 100%; height: 100px;"></textarea>
                    </div>
                    <div>
                        <button class="n2-button-icon" v-on:click="addNote()">
                            <i class="fa fa-sticky-note n2-button-item-icon" aria-hidden="true"></i>
                            <span class="n2-button-item-text">
                                {{ $t('pages.admin.order.add_note') }}
                            </span>
                        </button>
                    </div>
                    <div>
                        <div v-if="add_note_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.add_note_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>
                <app-loader v-bind:active="add_note_loading"></app-loader>

            </div>
        </div>

        <div id="n3-change-contact-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container" style="padding-bottom: 16px;">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.change_contact') }}
                    </h4>
                    <div v-if="order.contact">
                        <table>
                            <tr>
                                <td class="contact-title-field">
                                    {{ $t('pages.admin.order.given_name') }}
                                </td>
                                <td class="contact-value-field">
                                    <div>
                                        <input type="text" v-model="order.contact.given_name"
                                            class="n2-input-default" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="contact-title-field">
                                    {{ $t('pages.admin.order.family_name') }}
                                </td>
                                <td class="contact-value-field">
                                    <div>
                                        <input type="text" v-model="order.contact.family_name"
                                            class="n2-input-default" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="contact-title-field">
                                    {{ $t('pages.admin.order.email') }}
                                </td>
                                <td class="contact-value-field">
                                    <div>
                                        <input type="text" v-model="order.contact.email" class="n2-input-default" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="contact-title-field">
                                    {{ $t('pages.admin.order.phone_number') }}
                                </td>
                                <td class="contact-value-field">
                                    <div>
                                        <phone-number-field v-model="order.contact.phone_number"
                                    :defaultCountry="order.contact.address.country_code || 'NO'" :locale="app_locale"
                                    :errors="{ national: '' }" />
                                    </div>
                                </td>
                            </tr>
                            <template v-if="order.template != 'online_payment'">
                                <tr>
                                    <td class="contact-title-field">
                                        {{ $t('pages.admin.order.address') }}
                                    </td>
                                    <td class="contact-value-field">
                                        <div>
                                            <input type="text" v-model="order.contact.address.address_line_1"
                                                class="n2-input-default" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="contact-title-field">
                                        {{ $t('pages.admin.order.locality') }}
                                    </td>
                                    <td class="contact-value-field">
                                        <div>
                                            <input type="text" v-model="order.contact.address.locality"
                                                class="n2-input-default" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="contact-title-field">
                                        {{ $t('pages.admin.order.postal_code') }}
                                    </td>
                                    <td class="contact-value-field">
                                        <div>
                                            <input type="text" v-model="order.contact.address.postal_code"
                                                class="n2-input-default" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="contact-title-field">
                                        {{ $t('pages.admin.order.country_code') }}
                                    </td>
                                    <td class="contact-value-field">
                                        <div>
                                            <app-autocomplete v-model="order.contact.address.country_code"
                                                v-bind:items="countries" v-bind:text_field="'name'"
                                                v-bind:separator="' '" v-bind:value_field="'code'">
                                            </app-autocomplete>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </table>
                        <div>
                            <button style="margin: 20px 0 0 0;" v-on:click="updateContact" class="n2-button-1">{{
                                $t('pages.admin.order.update') }}</button>
                        </div>

                    </div>
                    <div>
                        <div v-if="change_contact_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.change_contact_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>

                <app-loader v-bind:active="change_contact_loading"></app-loader>

            </div>




        </div>

        <div id="n3-change-vehicle-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container" style="padding-bottom: 16px;">
                    <h4 class="n2-text-center">
                        {{ $t('pages.admin.order.change_vehicle') }}
                    </h4>
                    <div v-for="(v, index) in order.vehicles" v-bind:key="v"
                        style="border: 1px solid #cccccc; padding: 10px; margin-top: 10px;">
                        <div>
                            <div class="n2-form-group">
                                <label class="n2-form-label">{{ $t('pages.admin.order.vehicle') }} {{ index + 1 }}:
                                    {{ getProductName(v.product_id) }}</label>
                            </div>
                        </div>
                        <div>
                            <div style="width: 360px;">
                                <div>
                                    <form-input type="text" v-model="v.model"
                                        v-bind:label="$t('pages.admin.order.model')"
                                        v-bind:errors="v.model_errors"></form-input>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="width: 360px;">
                                <div>
                                    <form-input type="text" v-model="v.registration_number"
                                        v-bind:label="$t('pages.admin.order.registration_number')"
                                        v-bind:errors="v.registration_number_errors"></form-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button style="margin: 20px 0 0 0;" v-on:click="updateVehicles" class="n2-button-1">{{
                            $t('pages.admin.order.update') }}</button>
                    </div>
                    <div>
                        <div v-if="change_vehicle_success" style="margin: 20px 0;">
                            <h4>{{ $t('pages.admin.order.change_vehicle_success') }}</h4>
                        </div>
                        <div v-else class="n2-invalid_text">
                            <div v-if="modal_error" style="margin: 20px 0;">
                                {{ modal_error }}
                            </div>
                        </div>
                    </div>
                </div>

                <app-loader v-bind:active="change_vehicle_loading"></app-loader>

            </div>




        </div>
    </div>
</template>

<script>import { mapGetters } from 'vuex'
import { OrderService, ResourceService, EmailService, UserService } from '../services'
import helper from '../helpers/localization-helper'
import AppLoader from '../components/shared/loader.vue'
import QuestionContent from '../components/shared/question-content.vue'
import country_list from '../data/country-list'

import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import AppAutocomplete from '../components/shared/autocomplete.vue'
import AppTimelines from '../components/app/timelines.vue'
import PhoneNumberField from '../components/app/phone-number-field.vue'

export default {
    components: { FormInput, ValidationSummary, AppLoader, QuestionContent, AppAutocomplete, AppTimelines, PhoneNumberField },
    data: function () {
        return {
            timer: null,
            email_to_send: null,
            order: {},
            order_html: '',
            toolbar_loading: false,
            loading: false,
            cancel_leg_loading: false,
            cancel_order_loading: false,
            send_email_loading: false,
            refund_loading: false,
            parent_order: null,
            parent_order_html: '',
            parentHtmls: [],
            refund_amount: null,
            refund_validation_errors: {},
            modal_error: '',
            refund_success: false,
            selected_leg_id: null,
            send_success: false,
            add_note_success: false,
            add_note_loading: false,
            note: '',
            fee_amount: 0,
            add_fee_success: false,
            add_fee_loading: false,
            fee_type: null,
            leg_fee_amount: 0,
            add_leg_fee_success: false,
            add_leg_fee_loading: false,
            leg_fee_type: null,
            selected_leg: null,
            fee_amount_percentage: null,
            leg_fee_amount_percentage: null,
            vehicle_edit_visible: false,
            error_change_contact_time_passed: false,
            change_contact_success: false,
            change_contact_loading: false,
            change_vehicle_success: false,
            change_vehicle_loading: false,
            timelines: [],
        }
    },
    watch: {
        fee_amount_percentage: function (amount) {
            this.fee_amount = this.order.original_ticket_total * amount / 100;
        },
        leg_fee_amount_percentage: function (amount) {
            this.leg_fee_amount = this.selected_leg.original_ticket_total * amount / 100;
        },
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ]),
        trans: function () {
            if (this.order.transactions) {
                return this.order.transactions.filter(t => { return t.status == 'success' && (t.transaction_type == 'capture' || t.transaction_type == 'sale' || t.transaction_type == 'credit') })
            }
            return [];
        },
        countries: function () {
            if (this.app_locale == 'no') {
                return country_list.no
            }
            else {
                return country_list.en
            }
        }
    },
    created: function () {
        this.orderService = new OrderService();
        this.emailService = new EmailService();
        this.resourceService = new ResourceService();
        this.userService = new UserService();
    },
    mounted: async function () {
        const { id } = this.$route.params;
        try {
            this.loading = true;
            let res = await this.orderService.find(id)
            this.order = res;
            this.email_to_send = this.order.contact.email;
            this.order_html = await this.orderService.getHtml(this.order.id, this.order.template)
            if (this.order.parent_order_id) {
                this.loadParent(this.order.parent_order_id);
            }
            let tls = await this.orderService.getTimeLines(this.order.id)
            const userPromises = tls.map(async tl => {
                if (tl.operator_type == 'admin') {
                    tl.user = await this.userService.find(tl.operator_id);
                }
                return tl;
            });
            this.timelines = await Promise.all(userPromises);
        }
        finally {
            this.loading = false;
        }
        this.timer = setInterval(this.displayTime, 1000);
    },
    beforeMount: function () {
    },
    beforeDestroy: function () {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        displayTime: function () {
            if (this.order && this.order.legs) {
                for (let i = 0; i < this.order.legs.length; i++) {
                    let leg = this.order.legs[i];
                    leg.time_until_departure = helper.getDifferenceString(leg.steps[0].transit.depart_at.substring(0, 19) + 'Z', new Date().toISOString());
                    this.$set(this.order.legs, i, leg);
                }
            }
        },
        getDateTimeString: function (source) {
            return helper.getDateTimeString(source);
        },
        getShortDateTimeString: function (source) {
            return helper.getShortDateTimeString(source);
        },
        formatNumber: function (source) {
            return helper.formatNumber(source);
        },
        getLegTime: function (leg) {
            let timeString = `${leg.time_until_departure.total_seconds < 0 ? 0 : leg.time_until_departure.days}d ${leg.time_until_departure.total_seconds < 0 ? 0 : leg.time_until_departure.hours}h ${leg.time_until_departure.total_seconds < 0 ? 0 : leg.time_until_departure.minutes}m ${leg.time_until_departure.total_seconds < 0 ? 0 : leg.time_until_departure.seconds}s`;
            return timeString;
        },
        loadParent: async function (orderId) {
            let order = await this.orderService.find(orderId)

            let parentHtml = await this.orderService.getHtml(order.id, order.template)
            this.parentHtmls.push(parentHtml)
            if (order.parent_order_id) {
                await this.loadParent(order.parent_order_id)
            }
        },
        openModal: function (id) {
            this.modal_error = '';
            document.getElementById(id).style.display = 'block';
        },
        getCountryName: function (code) {
            return this.countries.find(c => c.code == code).name
        },
        getProductName: function (product_id) {
            return this.order.product_lines.find(p => p.product_id == product_id).title;
        },
        openEmailModal: function () {
            this.openModal('n3-send-email-modal')
            this.send_success = false;
        },
        sendEmail: async function () {
            this.modal_error = '';
            if (this.email_to_send) {
                this.send_success = false;
                this.send_email_loading = true;
                try {
                    let emailTrimmed = this.email_to_send.trim().toLowerCase();
                    if (this.order.status == 'cancelled') {
                        await this.emailService.sendOrderCancellationEmail(this.order.id, { email: emailTrimmed });
                    }
                    else {
                        let cancelledCount = this.order.legs.filter(l => l.status == 'cancelled').length;
                        if (cancelledCount > 0
                            && this.order.legs.length > cancelledCount) {
                            await this.emailService.sendLegCancellationEmail(this.order.id, { email: emailTrimmed });

                        }
                        else {
                            await this.emailService.sendOrderCreationEmail(this.order.id, { email: emailTrimmed });
                        }
                        this.send_success = true;
                    }
                }
                catch {
                    this.send_success = false;
                    this.modal_error = this.$t('pages.admin.order.failed')
                }
                finally {
                    this.send_email_loading = false;
                }
            }
        },
        openAddNoteModal: function () {
            this.openModal('n3-add-note-modal');
            this.add_note_success = false;
        },
        addNote: async function () {
            this.modal_error = '';
            this.add_note_success = false;
            try {
                this.add_note_loading = true;
                await this.orderService.addNote(this.locale, this.order.id, this.note);
                this.add_note_success = true;
            }
            catch {
                this.add_note_success = false;
                this.modal_error = this.$t('pages.admin.order.failed')
            }
            finally {
                this.add_note_loading = false;
            }
        },
        openCancelLegModal: function (id) {
            this.selected_leg_id = id;
            this.openModal('n3-cancel-leg-modal');
        },
        openRefundModal: function () {
            this.refund_amount = -this.order.outstanding_amount;
            this.refund_success = false;
            this.openModal('n3-refund-modal');
        },
        openAddFeeModal: function () {
            this.fee_amount = 0;
            this.fee_amount_percentage = 0;
            this.add_fee_success = false;
            this.fee_type = 'cancellation';
            this.openModal('n3-add-fee-modal');
        },
        openAddLegFeeModal: function (leg) {
            this.leg_fee_amount = 0;
            this.leg_fee_amount_percentage = 0;
            this.selected_leg = leg;
            this.add_leg_fee_success = false;
            this.leg_fee_type = 'cancellation';
            this.openModal('n3-add-leg-fee-modal');
        },
        getCancellationFee: async function () {
            try {
                this.add_fee_loading = true;
                let fee = await this.orderService.getCancellationFee(this.order.id);
                this.fee_amount = fee.fee_total;
                //this.fee_amount_percentage = parseInt(10000 * this.fee_amount / this.order.original_ticket_total) / 100;
            }
            finally {
                this.add_fee_loading = false;
            }
        },
        getLegCancellationFee: async function () {
            try {
                this.add_leg_fee_loading = true;
                let fee = await this.orderService.getLegCancellationFee(this.order.id, this.selected_leg.id);
                this.leg_fee_amount = fee.fee_total;
                //this.leg_fee_amount_percentage = parseInt(10000 * this.leg_fee_amount / this.selected_leg.original_ticket_total) / 100;
            }
            finally {
                this.add_leg_fee_loading = false;
            }
        },
        updateContact: async function () {
            this.change_contact_loading = true;
            this.change_contact_success = false;
            this.modal_error = '';
            let patternPhone = new RegExp(/^([+]{0,1})((?:\s*\d){8,})$/)

            if (!patternPhone.test(this.order.contact.phone_number)) {
                this.modal_error = this.$t('pages.admin.order.error_phone_number')
                this.change_contact_loading = false;

                return;
            }

            try {
                await this.orderService.updateContact(this.order.id, this.order.contact);
                this.change_contact_success = true;
                this.email_to_send = this.order.contact.email;
            }
            catch (err) {
                switch (err.data.error_code) {
                    case 'change_time_passed':
                        this.modal_error = this.$t('pages.admin.order.change_time_passed')
                        break;
                    default:
                        this.modal_error = this.$t('pages.admin.order.failed')
                }
            }
            finally {
                this.change_contact_loading = false;
            }
        },
        updateVehicles: async function () {
            this.change_vehicle_loading = true;
            this.change_vehicle_success = false;
            this.modal_error = '';
            try {
                await this.orderService.updateVehicles(this.order.id, this.order.vehicles);
                this.change_vehicle_success = true;
            }
            catch (err) {
                switch (err.data.error_code) {
                    default:
                        this.modal_error = this.$t('pages.admin.order.failed')
                }
            }
            finally {
                this.change_vehicle_loading = false;
            }

        },
        addFee: async function () {
            this.add_fee_success = false;
            this.modal_error = '';
            this.add_fee_loading = true;
            try {
                this.order = await this.orderService.addFee(this.order.id, { amount: this.fee_amount, fee_type: this.fee_type });
                this.add_fee_success = true;
            }
            catch (err) {
                switch (err.data.error_code) {
                    case 'incorrect_amount':
                        this.modal_error = this.$t('pages.admin.order.incorrect_amount')
                        break;
                    default:
                        this.modal_error = this.$t('pages.admin.order.failed')
                }
            }
            finally {
                this.add_fee_loading = false;
            }
        },
        addLegFee: async function () {
            this.add_leg_fee_success = false;
            this.modal_error = '';
            try {
                this.add_leg_fee_loading = true;
                this.order = await this.orderService.addLegFee(this.order.id, this.selected_leg.id, { amount: this.leg_fee_amount, fee_type: this.leg_fee_type });
                this.add_leg_fee_success = true;
            }
            catch (err) {
                switch (err.data.error_code) {
                    case 'incorrect_amount':
                        this.modal_error = this.$t('pages.admin.order.incorrect_amount')
                        break;
                    default:
                        this.modal_error = this.$t('pages.admin.order.failed')
                }
            }
            finally {
                this.add_leg_fee_loading = false;
            }
        },
        refund: async function () {
            if (this.refund_amount > 0) {
                this.refund_success = false;
                this.modal_error = '';
                try {
                    this.refund_loading = true;
                    await this.orderService.refund(this.order.id, this.refund_amount)
                    this.refund_success = true;
                    this.order = await this.orderService.find(this.order.id)
                }
                catch (err) {
                    switch (err.data.error_code) {
                        case 'incorrect_amount':
                            this.modal_error = this.$t('pages.admin.order.incorrect_amount')
                            break;
                        default:
                            this.modal_error = this.$t('pages.admin.order.failed')
                    }
                }
                finally {
                    this.refund_loading = false;
                }
            }
            else {
                console.log('not big than 0')
            }
        },
        cancel: async function () {
            this.modal_error = '';
            try {
                this.cancel_order_loading = true;
                this.order = await this.orderService.cancel(this.order.id)
                this.closeModal();
            }
            catch {
                this.modal_error = this.$t('pages.admin.order.failed')
            }
            finally {
                this.cancel_order_loading = false;
            }
        },
        cancelLeg: async function () {
            this.modal_error = '';
            try {
                this.cancel_leg_loading = true;
                this.order = await this.orderService.cancelLeg(this.order.id, this.selected_leg_id)
                this.closeModal();
            }
            catch {
                this.modal_error = this.$t('pages.admin.order.failed')
            }
            finally {
                this.cancel_leg_loading = false;
            }
        },
        openSupport: async function () {
            this.result_error = '';
            try {
                this.toolbar_loading = true;
                await this.orderService.openSupport(this.order.id)
                this.order.support_status = 'open'
            }
            catch {
                this.result_error = this.$t('pages.admin.order.failed')
            }
            finally {
                this.toolbar_loading = false;
            }
        },
        closeSupport: async function () {
            this.result_error = '';
            try {
                this.toolbar_loading = true;
                await this.orderService.closeSupport(this.order.id)
                this.order.support_status = 'closed'
            }
            catch {
                this.result_error = this.$t('pages.admin.order.failed')
            }
            finally {
                this.toolbar_loading = false;
            }
        },
        download: async function (order) {
            this.loading = true
            try {
                let pdf = await this.orderService.getPdf(order.id, order.template)
                const file = new Blob(
                    [pdf],
                    { type: 'application/pdf' });
                var url = window.URL.createObjectURL(file)
                var a = document.createElement('a')
                a.href = url
                a.download = order.booking_number
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            }
            finally {
                this.loading = false;
            }
        },

        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        }
    }
}</script>
